import './promise-extends';
import SxAjax from './sx-ajax';
import _createHoc from './create-hoc';
import _createHooks from './create-hooks';

export default SxAjax;
export const createHoc = _createHoc;
export const createHooks = _createHooks;
